import {
  createIcon as publicCreateIcon,
  getIcon as publicGetIcon,
  updateIconMetadata as publicUpdateIconMetadata,
  deleteIcon as publicDeleteIcon,
  searchIcons as publicSearchIcons,
  bulkUpdateIconTags as publicBulkUpdateIconTags,
  bulkUpdateIconTagsByFilter as publicBulkUpdateIconTagsByFilter,
  bulkSeedIcons as publicBulkSeedIcons,
} from './enterprise-web-five-v1-icon-icons.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

/** @internal */
export const createIcon: MaybeContext<
  BuildRESTFunction<typeof publicCreateIcon> & typeof publicCreateIcon
> = /*#__PURE__*/ createRESTModule(publicCreateIcon);
/** @internal */
export const getIcon: MaybeContext<
  BuildRESTFunction<typeof publicGetIcon> & typeof publicGetIcon
> = /*#__PURE__*/ createRESTModule(publicGetIcon);
/** @internal */
export const updateIconMetadata: MaybeContext<
  BuildRESTFunction<typeof publicUpdateIconMetadata> &
    typeof publicUpdateIconMetadata
> = /*#__PURE__*/ createRESTModule(publicUpdateIconMetadata);
/** @internal */
export const deleteIcon: MaybeContext<
  BuildRESTFunction<typeof publicDeleteIcon> & typeof publicDeleteIcon
> = /*#__PURE__*/ createRESTModule(publicDeleteIcon);
/** @internal */
export const searchIcons: MaybeContext<
  BuildRESTFunction<typeof publicSearchIcons> & typeof publicSearchIcons
> = /*#__PURE__*/ createRESTModule(publicSearchIcons);
/** @internal */
export const bulkUpdateIconTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateIconTags> &
    typeof publicBulkUpdateIconTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateIconTags);
/** @internal */
export const bulkUpdateIconTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateIconTagsByFilter> &
    typeof publicBulkUpdateIconTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateIconTagsByFilter);
/** @internal */
export const bulkSeedIcons: MaybeContext<
  BuildRESTFunction<typeof publicBulkSeedIcons> & typeof publicBulkSeedIcons
> = /*#__PURE__*/ createRESTModule(publicBulkSeedIcons);

export {
  TenantScope,
  WebhookIdentityType,
} from './enterprise-web-five-v1-icon-icons.universal.js';
export {
  Icon,
  ExtendedFields,
  Tags,
  TagList,
  IconTagsModified,
  CreateIconRequest,
  CreateIconResponse,
  GetIconRequest,
  GetIconResponse,
  UpdateIconMetadataRequest,
  UpdateIconMetadataResponse,
  DeleteIconRequest,
  DeleteIconResponse,
  SearchIconsRequest,
  IconFilter,
  CursorPaging,
  SearchIconsResponse,
  SearchedIcon,
  CursorPagingMetadata,
  Cursors,
  BulkUpdateIconTagsRequest,
  BulkUpdateIconTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdateIconTagsResult,
  BulkActionMetadata,
  BulkUpdateIconTagsByFilterRequest,
  BulkUpdateIconTagsByFilterResponse,
  BulkSeedIconsRequest,
  SeedItem,
  SeedItemSourceOneOf,
  BulkSeedIconsResponse,
  SeedResult,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  CreateIconOptions,
  UpdateIconMetadataIcon,
  SearchIconsOptions,
  BulkUpdateIconTagsOptions,
  BulkUpdateIconTagsByFilterOptions,
} from './enterprise-web-five-v1-icon-icons.universal.js';
export {
  TenantScopeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  BulkUpdateIconTagsApplicationErrors,
  BulkUpdateIconTagsByFilterApplicationErrors,
} from './enterprise-web-five-v1-icon-icons.universal.js';
